import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { TextInput, RadioOrSelect } from "@egovernments/digit-ui-react-components";
import { Box, IconButton } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';


const LandDevelopment = ({ landDevelopment, handlePlotChange, handlePlotAreaChange, handlePropertyTypeChange, addLandRow, deleteLandRow, propertyTypeOptions, t }) => {
  let validation = {}
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t("CSS_COMMON_PLOTNO")}</TableCell>
          <TableCell>{t("CSS_COMMON_PLOTAREA")}</TableCell>
          <TableCell>{t("CSS_COMMON_PLOTTYPE")}</TableCell>
          <TableCell>{t("CSS_COMMON_ADD")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {landDevelopment.map((elementInArray, index) => (
          <TableRow key={index}>
            <TableCell>
              <TextInput
                t={t}
                type="text"
                isMandatory={false}
                optionKey="i18nKey"
                name="plotNo"
                value={elementInArray.plotNo}
                onChange={(e) => handlePlotChange(e, index)}
                {...(validation = {
                  isRequired: true,
                  pattern: "^[a-zA-Z-.`' ]*$",
                  type: "text",
                  title: t("PT_NAME_ERROR_MESSAGE"),
                })}
              />
            </TableCell>
            <TableCell>
              <TextInput
                t={t}
                type="text"
                isMandatory={false}
                optionKey="i18nKey"
                name="PlotArea"
                value={elementInArray.plotarea}
                onChange={(e) => handlePlotAreaChange(e, index)}
              />
            </TableCell>
            <TableCell style={{ width: '40%' }}>
              <RadioOrSelect
                name="propertyType"
                optionKey="i18nKey"
                options={propertyTypeOptions}
                onSelect={(code) => handlePropertyTypeChange(code, index)}
                selectedOption={elementInArray?.landType?.code}
                t={t}
              />
            </TableCell>
            <TableCell style={{ width: '20%' }}>
              <Box sx={{ display: 'flex', gap: '.5rem', mt: "-1.2rem", ml: '.5rem' }}>
                <IconButton color="primary" aria-label="add" onClick={addLandRow}>
                  <AddBoxIcon />
                </IconButton>
                {index > 0 && (
                  <IconButton color="error" aria-label="delete" onClick={() => deleteLandRow(index)}>
                    <DeleteIcon />
                  </IconButton>
                )}
              </Box>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default LandDevelopment;
